module.exports = __webpack_public_path__ + "img/男生头像正.90999036.png";